import React, { useState } from "react";
import "../layout/Home/Home.css";
import { Link } from "react-router-dom"; 
import "./MedicalEquipments.css";
import AddIcon from "@mui/icons-material/Add";
import StarPurple500OutlinedIcon from "@mui/icons-material/StarPurple500Outlined";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { fetchAPI } from "../utils/api";
import { ShimmerThumbnail, ShimmerTitle, ShimmerButton } from "react-shimmer-effects";

function EquipmentCard({ equipment, onShowToast }) {
  const rentalOptions = equipment.attribute || [];
  
  // Default to index 0 if attributes exist
  const [selectedAttrIndex, setSelectedAttrIndex] = useState(0);
  
  const currentAttr = rentalOptions[selectedAttrIndex] || null;
  const displayPrice = currentAttr ? currentAttr.price : (equipment.me_security_amount || "0");
  
  const handleOptionClick = (e, idx) => {
    e.preventDefault();
    e.stopPropagation();
    setSelectedAttrIndex(idx);
  };

  const saveToLocalCart = (productObj, selectedAttr) => {
    try {
      const saved = localStorage.getItem("selectedProductCart");
      let cartList = [];
      if (saved) {
        try {
          cartList = JSON.parse(saved);
          if (!Array.isArray(cartList)) cartList = [];
        } catch (e) {
          cartList = [];
        }
      }

      const existingItemIndex = cartList.findIndex(
        (item) => String(item.product_id) === String(productObj.me_id) && String(item.attribute_value_id || item.id) === String(selectedAttr.attribute_value_id)
      );

      if (existingItemIndex === -1) {
        const cartItem = {
          id: selectedAttr.attribute_value_id,
          attribute_value_id: selectedAttr.attribute_value_id,
          product_id: productObj.me_id,
          name: productObj.me_product_name,
          duration: selectedAttr.attribute_value,
          price: selectedAttr.price,
          security_amount: productObj.me_security_amount || "0",
          image: productObj.me_image || "/placeholder.png",
          type: "equipment",
          qty: 1
        };
        cartList.push(cartItem);
      } else {
        cartList[existingItemIndex].qty = (cartList[existingItemIndex].qty || 1) + 1;
      }

      localStorage.setItem("selectedProductCart", JSON.stringify(cartList));
      localStorage.setItem("activeCartType", "product");
      window.dispatchEvent(new Event("cartUpdated"));
    } catch (err) {
      console.error("Error saving to local cart:", err);
    }
  };

  const handleAddToCart = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    const userStr = localStorage.getItem('user');
    if (!userStr) {
      if (onShowToast) onShowToast("Please sign in to add products to your cart.", "warning");
      window.dispatchEvent(new Event("openLoginModal"));
      return;
    }
    
    let user;
    try {
      user = JSON.parse(userStr);
    } catch (err) {
      console.error("Error parsing user from localStorage:", err);
      if (onShowToast) onShowToast("Please sign in to add products to your cart.", "warning");
      window.dispatchEvent(new Event("openLoginModal"));
      return;
    }
    
    if (!user || !user.user_id) {
      if (onShowToast) onShowToast("Please sign in to add products to your cart.", "warning");
      window.dispatchEvent(new Event("openLoginModal"));
      return;
    }
    
    if (!currentAttr) {
      if (onShowToast) onShowToast("Please select a pricing plan (Rent days) first.", "warning");
      return;
    }

    try {
      const response = await fetchAPI('EquipmentsController/add_to_cart', {
        method: 'POST',
        body: JSON.stringify({
          user_id: user.user_id,
          product_id: equipment.me_id,
          attribute_value_id: currentAttr.attribute_value_id,
          qty: 1
        })
      });
      
      if (response && response.status === 200) {
        saveToLocalCart(equipment, currentAttr);
        if (onShowToast) onShowToast("Cart added successfully!", "success");
      } else {
        if (onShowToast) onShowToast(response.msg || "Failed to add product to cart.", "error");
      }
    } catch (err) {
      console.error("Error adding to cart:", err);
      if (onShowToast) onShowToast("Something went wrong. Please try again.", "error");
    }
  };

  return (
    <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
      <Link to={`/product/${equipment.me_slug || equipment.me_id}`} state={{ product: equipment, selectedAttrIndex, selectedAttrId: currentAttr?.attribute_value_id, selectedAttribute: currentAttr }}>
        <div className="equip-box">
          {/* Label as bestseller if me_category is 1 for visual flair */}
          {equipment.me_category === "1" && (
            <span className="badge">Bestseller</span>
          )}

          <div className="eqip-img">
            <img src={equipment.me_image || "/placeholder.png"} alt={equipment.me_product_name} className="img-fluid" />
          </div>

          <div className="equipment_content">
            <label className="product_name_onrent">{equipment.me_product_name}</label>

            <div className="star_review">
              <div className="stars">
                <StarPurple500OutlinedIcon />
                <StarPurple500OutlinedIcon />
                <StarPurple500OutlinedIcon />
                <StarPurple500OutlinedIcon />
                <StarPurple500OutlinedIcon />
              </div>

              <p className="starpera">
                <span> 4.8 </span>
              </p>
            </div>
            <div className="days-booking">
              <p>Rent : </p>
              {rentalOptions.map((opt, idx) => (
                <span 
                  key={opt.attribute_value_id}
                  onClick={(e) => handleOptionClick(e, idx)}
                  style={{
                    cursor: 'pointer',
                    backgroundColor: selectedAttrIndex === idx ? '#13baac' : '#ffffff',
                    borderColor: selectedAttrIndex === idx ? '#13baac' : '#d7d7d7',
                    color: selectedAttrIndex === idx ? '#ffffff' : 'var(--dark-grey)',
                    userSelect: 'none'
                  }}
                >
                  {opt.attribute_value}
                </span>
              ))}
            </div>
            <div className="price-divider"></div>

            <div className="price-row">
              <div className="medicine-price">
                <span className="sale-price">
                  ₹{displayPrice}
                  {currentAttr && currentAttr.attribute_value ? (
                    <span style={{ fontSize: '13px', fontWeight: '500', color: '#666', marginLeft: '3px', textTransform: 'lowercase' }}>
                      / {currentAttr.attribute_value.toLowerCase()}
                    </span>
                  ) : '/-'}
                </span>
              </div>
              <button className="medicine-add-btn">
                Add
              </button>
            </div>
          </div>
        </div>
      </Link>
    </div>
  );
}

function Equipments({ equipments = [], loading = false }) {
  const [toast, setToast] = useState({ show: false, message: "", type: "success" });

  const showToast = (message, type = "success") => {
    setToast({ show: true, message, type });
    setTimeout(() => {
      setToast({ show: false, message: "", type: "success" });
    }, 3000);
  };

  if (loading) {
    return (
      <div className="medical-equipments-main w-100">
        <div className="row g-3">
          {[1, 2, 3, 4, 5, 6].map((item) => (
            <div key={item} className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
              <div 
                className="equip-box p-3" 
                style={{ 
                  background: "#ffffff", 
                  borderRadius: "12px", 
                  border: "1px solid #f0f0f0",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.03)"
                }}
              >
                <ShimmerThumbnail height={170} rounded className="mb-3" />
                <ShimmerTitle line={1} gap={10} variant="primary" />
                <ShimmerTitle line={1} gap={10} variant="secondary" />
                <div className="d-flex justify-content-between align-items-center mt-3 pt-2" style={{ borderTop: "1px solid #f5f5f5" }}>
                  <div style={{ width: "45%" }}>
                    <ShimmerTitle line={1} gap={0} variant="primary" />
                  </div>
                  <ShimmerButton size="sm" />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (equipments.length === 0) {
    return (
      <div className="col-12 text-center py-5">
        <h4 className="text-muted">No products found matching filters.</h4>
      </div>
    );
  }

  return (
    <>
      {toast.show && (
        <div className={`custom-toast-notification custom-toast-${toast.type}`}>
          <CheckCircleIcon />
          <span>{toast.message}</span>
        </div>
      )}
      <div className="medical-equipments-main">
        <div className="row g-3">
          {equipments.map((equipment) => (
            <EquipmentCard key={equipment.me_id} equipment={equipment} onShowToast={showToast} />
          ))}
        </div>
      </div>
    </>
  );
}

export default Equipments;
